import React, { useState, useEffect } from 'react';

const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timerId);
    };
  }, []);

  const dateOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  const timeOptions = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };

  const formattedDate = new Intl.DateTimeFormat('id-ID', dateOptions).format(time);
  const formattedTime = new Intl.DateTimeFormat('id-ID', timeOptions).format(time).replace(/\./g, ':');

  return (
    // Menggunakan className, bukan inline style
    <div className="clock-container">
      <div className="clock-time">
        {formattedTime}
      </div>
      <div className="clock-date">
        {formattedDate}
      </div>
    </div>
  );
};

export default Clock;